import React, { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import AdminTable from "src/pages/Administrator/Helpers/AdminTable"
import { useState, useMemo } from "react"
import { getPaymentReminders } from "src/store/Slices/Administrator/PaymentRemindersSlice"
import dayjs from "dayjs"

const PaymentReminders = () => {
  const dispatch = useDispatch()

  const [page, setPage] = useState(1)
  const [pageSize, setPageSize] = useState(20)
  const [filters, setFilters] = useState({})

  const PaymentRemindersListLoading = useSelector(
    (state) => state.PaymentRemindersSlice?.PaymentRemindersListLoading,
  )
  const PaymentRemindersList = useSelector(
    (state) => state.PaymentRemindersSlice?.PaymentRemindersList,
  )

  const searchItemsMap = (keys, values) => {
    const formattedItems = {}
    if (keys && values) {
      keys.forEach((key, index) => {
        if (values[index] !== undefined && values[index] !== null && values[index][0] !== undefined && values[index][0] !== null) {
          const value = values[index][0]
          
          if (key === "sendDate" && Array.isArray(value)) {
            formattedItems["sendDate.From"] = dayjs(value[0]).format("YYYY-MM-DD")
            formattedItems["sendDate.To"] = dayjs(value[1]).format("YYYY-MM-DD")
          }
          else if (key === "isSent") {
            formattedItems["isSent"] = value
          }
          else if (key === "clientName") {
            formattedItems["clientName"] = value
          }
          else if (!Array.isArray(value)) {
            formattedItems[key] = value
          }
        }
      })
    }
    return formattedItems
  }

  const loadPaymentReminders = (filterParams = {}) => {
    dispatch(
      getPaymentReminders({
        value: {
          count: pageSize,
          offset: pageSize * (page - 1),
          ...filterParams,
        },
      })
    )
  }

  const handleTableChange = (pagination, tableFilters, sorter) => {
    const payload = searchItemsMap(Object.keys(tableFilters), Object.values(tableFilters))
    
    setFilters(payload)
  
    dispatch(
      getPaymentReminders({
        value: {
          count: pagination.pageSize,
          offset: pagination.pageSize * (pagination.current - 1),
          orderBy: sorter?.column?.dataIndex,
          isDesc: sorter.order ? sorter.order === "descend" : undefined,
          ...payload,
        },
      })
    )
    
    setPage(pagination.current)
    setPageSize(pagination.pageSize)
  }

  useEffect(() => {
    loadPaymentReminders(filters)
  }, [page, pageSize])

  const formattedPaymentRemindersRows = useMemo(() => {
    if (!PaymentRemindersList?.data?.value?.rows) return []
    
    return PaymentRemindersList.data.value.rows.map((element) => ({
      ...element,
      sendDate: element.sendDate ? dayjs(element.sendDate).format("DD.MM.YYYY HH:mm") : "",
    }))
  }, [PaymentRemindersList])

  return (
    <>
      {window.innerWidth >= 768 ? (
        <AdminTable
          page={page}
          setPage={setPage}
          pageSize={pageSize}
          setPageSize={setPageSize}
          onChange={handleTableChange}
          loading={PaymentRemindersListLoading}
          columns={PaymentRemindersList}
          rows={formattedPaymentRemindersRows}
          total={PaymentRemindersList?.data?.value?.totalCount}
        />
      ) : (
        <AntdMobileTable
          page={page}
          setPage={setPage}
          pageSize={pageSize}
          setPageSize={pageSize}
          elementsList={PaymentRemindersList}
          elementsListLoading={PaymentRemindersListLoading}
          handlePaginationChange={handlePaginationChange}
        />
      )}
    </>
  )
}

export default PaymentReminders